module.exports = __webpack_public_path__ + "img/conteesa.3673dccc.png";